export const bsrAmData = {
  path: '/bsr-am',
  breadcrumb: [
    ['Formations 2 & 3 roues', '/formation'],
    ['Permis AM (BSR)', '/bsr-am'],
  ],
  kicker: 'Permis AM · cyclomoteur · dès 14 ans',
  title: 'Permis AM',
  titleHighlight: 'BSR ou cyclomoteur.',
  subtitle:
    "Le permis AM (anciennement BSR) est obligatoire dès 14 ans pour conduire un cyclomoteur (50 cm³) ou un quadricycle léger (voiture sans permis). 8h de formation + ASSR.",
  seoTitle: 'Permis AM (BSR) — Cyclomoteur 50 cm³ dès 14 ans · Le guide ECSR',
  seoDescription:
    'Tout savoir sur le permis AM (ex-BSR) : conditions, durée (8h), prix, ASSR obligatoire, déroulement de la formation, équipement. Pour conduire un 50 cm³ ou une voiturette dès 14 ans.',
  seoKeywords:
    'permis AM, BSR, BSR moto, brevet sécurité routière, permis 50cc, cyclomoteur 14 ans, voiturette permis AM, formation 8h cyclomoteur, ASSR1 ASSR2',
  heroImage:
    'https://images.unsplash.com/photo-1547549082-6bc09f2049ae?w=2400&q=85&auto=format&fit=crop',
  heroImageAlt: 'Adolescent en formation BSR / permis AM',
  duration: '8 heures de formation',
  cost: '~ 200 à 350 €',
  timeRequired: 'PT8H',
  about: 'Permis AM, BSR, cyclomoteur 50 cm³, voiturette',
  primaryCta: { label: 'Voir les formations', to: '/formation' },
  secondaryCta: { label: 'Préparer l\'ASSR', to: '/assr' },
  relatedTopic: 'bsr-am',
  accentColor: '#0891b2',

  intro:
    "<p>Le <strong>permis AM</strong> (anciennement <strong>BSR</strong> — Brevet de Sécurité Routière) est <strong>obligatoire dès 14 ans</strong> pour conduire un <strong>cyclomoteur</strong> (jusqu'à 50 cm³ et 45 km/h) ou un <strong>quadricycle léger</strong> (voiturette). Il a été instauré pour réduire la mortalité des jeunes conducteurs sur deux-roues.</p><p>La formation dure <strong>8 heures</strong> minimum, organisée en <strong>5 séquences réglementaires</strong> : 1h théorie (échanges + Code de la route), 3h plateau (hors circulation), 3h circulation, et <strong>1h de sensibilisation aux risques avec présence d'au moins un parent ou représentant légal si l'élève est mineur</strong>. Elle nécessite la possession préalable de l'<strong>ASSR 1</strong> ou <strong>ASSR 2</strong> (passées au collège). Pour les non-scolarisés : ASR (Attestation de Sécurité Routière). Le permis AM est délivré à l'issue de la formation, sans examen final, mais avec une évaluation continue par le formateur.</p>",

  conditions: [
    {
      title: 'Avoir 14 ans révolus',
      text: 'Âge minimum pour passer la formation. La conduite d\'un cyclomoteur sans permis AM avant 14 ans est interdite.',
    },
    {
      title: 'ASSR 1 ou ASSR 2',
      text: 'Attestation Scolaire de Sécurité Routière passée en classe de 5ᵉ (ASSR 1) ou en 3ᵉ (ASSR 2). Sans ASSR, l\'inscription est refusée.',
    },
    {
      title: 'ASR pour non-scolarisés',
      text: 'Pour les jeunes ayant quitté le système scolaire : Attestation de Sécurité Routière (ASR), passée auprès des Greta ou organismes équivalents.',
    },
    {
      title: 'Aucun examen théorique',
      text: 'Pas d\'ETM, pas de Code à passer. La formation est continue : le formateur valide les compétences au fil des 8 heures.',
    },
  ],

  steps: [
    {
      title: 'Vérifier ton ASSR',
      duration: '1 jour',
      text: 'Demande à ton établissement scolaire un duplicata d\'ASSR si tu l\'as perdue. Sans ASSR, aucune moto-école ne pourra t\'inscrire au permis AM.',
    },
    {
      title: 'Module théorique (2h)',
      duration: '2 heures',
      text: 'Sensibilisation à la sécurité routière, équipement obligatoire, règles de circulation, conduite éco-responsable. Avec présence d\'un parent obligatoire pour les mineurs.',
    },
    {
      title: 'Module pratique hors circulation (3h)',
      duration: '3 heures',
      text: 'Apprentissage du démarrage, freinage, manœuvres lentes, équilibre, slalom. En piste fermée. Pas de mise en circulation à ce stade.',
    },
    {
      title: 'Module pratique en circulation (3h)',
      duration: '3 heures',
      text: 'Conduite réelle en agglomération avec le formateur en moto à proximité. Apprentissage des trajectoires, intersections, dépassements, contrôles visuels.',
    },
    {
      title: 'Délivrance du permis AM',
      duration: 'Immédiate',
      text: 'Le formateur valide la formation. Tu reçois une attestation provisoire (CEPC : Certificat d\'Examen du Permis de Conduire), puis le permis AM officiel sous quelques semaines.',
    },
  ],

  erreurs: [
    {
      title: 'Croire que le BSR ne sert plus',
      text: 'Depuis 2013, le BSR est devenu le \"permis AM\". Même nom, même formation : il est toujours obligatoire dès 14 ans pour un 50 cm³.',
    },
    {
      title: 'Sous-estimer la sécurité',
      text: 'Les 14-17 ans sont surreprésentés dans les accidents en cyclomoteur. Casque, gants, vêtements résistants : non-négociables.',
    },
    {
      title: 'Débrider le 50 cm³',
      text: 'Un cyclomoteur 50 cm³ doit rester limité à 45 km/h. Le débridage est interdit, dangereux, et entraîne saisie + amende.',
    },
    {
      title: 'Penser que c\'est seulement pour les jeunes',
      text: 'Le permis AM est aussi requis pour les adultes nés après le 1ᵉʳ janvier 1988 qui veulent conduire un cyclomoteur ou une voiturette sans avoir le permis B.',
    },
  ],

  conseils: [
    'Casque + gants + blouson + chaussures montantes : équipement complet obligatoire en formation et après.',
    'Choisis une moto-école qui te fait conduire dans des conditions variées (ville, pluie...).',
    'En cas de doute en circulation : ralentis, ne dépasse pas, ne force pas le passage.',
    'Le permis AM permet de conduire jusqu\'à 45 km/h max. Respecte cette limite, c\'est ta sécurité.',
    'À 16 ans, pense au permis A1 (125 cm³) pour passer au niveau supérieur.',
  ],

  faq: [
    {
      q: 'Quelle est la différence entre le BSR et le permis AM ?',
      a: 'Aucune en pratique : le BSR a été renommé permis AM en 2013, dans le cadre de l\'harmonisation européenne. C\'est la même formation (8h), les mêmes prérequis (ASSR), et le même droit de conduire (cyclomoteur 50 cm³ ou voiturette).',
    },
    {
      q: 'Faut-il le permis AM pour tous les 50 cm³ ?',
      a: 'Oui, pour toute personne née après le 1ᵉʳ janvier 1988. Avant cette date, certaines équivalences existent (le permis B donne accès au cyclomoteur). Vérifier sur le site de la Sécurité routière.',
    },
    {
      q: 'Le permis AM permet-il de conduire un scooter 125 cm³ ?',
      a: 'NON. Le permis AM est limité aux cyclomoteurs (50 cm³ max) et quadricycles légers. Pour un 125 cm³, il faut le permis A1 (16 ans minimum) ou le permis B avec 2 ans + formation 7h.',
    },
    {
      q: 'Combien coûte le permis AM en 2026 ?',
      a: 'Entre 200 et 350 € selon les moto-écoles et les régions. Le tarif inclut les 8 heures de formation, l\'attestation et la délivrance du permis. Aucun examen final, donc pas de frais d\'examen.',
    },
    {
      q: 'Peut-on passer le permis AM sans ASSR ?',
      a: 'Non, sauf cas dérogatoire avec ASR (pour les non-scolarisés). L\'ASSR (1 ou 2) est un prérequis légal absolu pour s\'inscrire en moto-école.',
    },
    {
      q: 'Le permis AM est-il valable à l\'étranger ?',
      a: 'Oui, dans tous les pays de l\'Union européenne (catégorie AM harmonisée). Hors UE : à vérifier (parfois nécessaire d\'obtenir un permis international en complément).',
    },
  ],

  sourceLabel:
    'Code de la route articles R211-2 et suivants, arrêté du 8 novembre 2012, Sécurité routière.',
  sourceUrl: 'https://www.service-public.fr/particuliers/vosdroits/F2226',
};
